exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".CatalogFilter_root__TabE2 {\n  flex: 1 1 auto;\n  max-width: 200px;\n  position: relative;\n  z-index: 2; }\n\n.CatalogFilter_loader__32-L7 {\n  text-align: right;\n  vertical-align: middle; }\n  .CatalogFilter_loader__32-L7 svg {\n    height: 30px;\n    width: 60px; }\n", ""]);

// Exports
exports.locals = {
	"root": "CatalogFilter_root__TabE2",
	"loader": "CatalogFilter_loader__32-L7"
};